<template>
  <SearchBar>
    <el-select
      size="small"
      :value="searchParams.searchType"
      @change="handleChangeSearchType"
    >
      <el-option :label="this.$t('search.selDuration')" value=""></el-option>
      <el-option :label="this.$t('search.today')" value="day"></el-option>
      <el-option :label="this.$t('search.week')" value="week"></el-option>
      <el-option :label="this.$t('search.month')" value="month"></el-option>
    </el-select>
    <el-select
      size="small"
      style="margin-left:15px"
      :value="searchParams.result"
      @change="handleChangeStatus"
    >
      <el-option :label="this.$t('search.selStatus')" value=""></el-option>
      <el-option :label="this.$t('search.success')" value="1"></el-option>
      <el-option :label="this.$t('search.fail')" value="2"></el-option>
      <el-option :label="this.$t('search.running')" value="0"></el-option>
    </el-select>
    <el-select
      size="small"
      style="margin-left:15px"
      :value="searchParams.robotIDs"
      @change="handleChangeRobot" 
      multiple 
    >
      <el-option :label="this.$t('search.selRobot')" value=""></el-option>
      <el-option v-for="robot in robotList" v-bind:key="robot.id" v-bind:label="robot.name" v-bind:value="robot.id">
      </el-option>
    </el-select>

    <el-input v-model="searchParams.filename" maxlength="50" style="width: 180px;margin-left:15px" size="small" :placeholder="this.$t('search.file')"></el-input>

    <el-button-group>
      <el-button size="small" type="primary" @click="handleSearch" style="margin-left: 15px;">{{this.$t('search.search')}}</el-button>
      <el-button size="small" @click="handleReset">{{this.$t('search.reset')}}</el-button>
    </el-button-group>

  </SearchBar>
</template>

<script>
import SearchBar from "@/components/common/SearchBar.vue";
import { list } from "@/api/robot";
import { mapState } from "vuex";
export default {
  name: "SearchCriterial",
  components: { SearchBar },
  props: {
    handleReset: Function,
    searchParams: Object,
    handleChangeSearchParams: Function,
    handleSearch: Function
  },
  data: () => {
    return {
      robotList: [],
      functionFlg: false
    };
  },
  mounted() {
    this.getSelectItem();
    this.searchParams.searchType = "day";
  },
  methods: {
    getSelectItem() {
      list({
        userID: this.accountInfo.userID
      }).then(response => {
        this.robotList = response.data.items;
      });
    },
    handleChangeSearchType(val) {
      this.handleChangeSearchParams({ ...this.searchParams, searchType: val });      
    },
    handleChangeStatus(val) {
      this.handleChangeSearchParams({ ...this.searchParams, result: val });      
    },
    handleChangeRobot(val) {
      this.handleChangeSearchParams({ ...this.searchParams, robotIDs: val });      
    }
  },
  computed: {
    ...mapState(["accountInfo"])
  }
};
</script>
